import { apiAction } from "../models/requests";
import { ENABLE_UI_SERVER_LOGGING } from "../constants/Constants.js";

const appendTokenName = (data) => {
    return data;
};

export function serverLog(log, trace){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    log.client_timestamp = new Date().toISOString();

    let level = log.level || "info";

    switch (level) {
        case "debug":
            console.debug(log);
            break;
        case "info":
            console.info(log);
            break;
        case "warning":
            console.warn(log);
            break;
        case "error":
            console.error(log);
            break;
        default:
            console.log(log);
        }

    if (trace){
        console.trace(log);
    }

    data.logs = [log];
    appendTokenName(data);
    if (ENABLE_UI_SERVER_LOGGING) {
        return apiAction({
            types: ["SERVER_LOG_REQUESTED", "SERVER_LOG_SUCCESS", "SERVER_LOG_FAILED"],
            method: "POST",
            path: "ui_log",
            body: data
        });
    }
    else {
        return {type: null};
    }
}